import React, { Component } from "react";
import { connect } from "react-redux";
import IntlMessages from "../../utils/IntlMessages";
import {
  collapsedAllMenu,
  signupOpenNoti,
  signinOpenNotFound,
  validateToken,
  authClosePopup,
} from "../../actions";
import { Button } from "reactstrap";
import renderFieldInputText from "../../utils/CustomField/renderFieldInputText";
import { Link } from "react-router-dom";
import authenBanner from "../../assets/images/authen-banner.jpg";
import LogoWrs from "../../assets/images/WRSLOGO.png";
import { authSignIn } from "../../actions";
import { reduxForm, Field } from "redux-form";
import PopupSignUpNoti from "../../components/popup/signup/PopupSignUpNoti";
import PopupSignInNotFound from "../../components/popup/signin/PopupSignInNotFound";

class signInModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      username: "",
      password: "",
      signInDisplayPassword: false,
      signUpDisplayPassword: false,
      signUpDisplayPasswordConfirm: false,
      signup_name: "",
      signup_mobile: "",
      signup_email: "",
      signup_password: "",
      signup_password_confirm: "",
      isChecked: true,
      action: "create",
    };
  }
  toggleSignInDisplayPassword() {
    this.setState({
      signInDisplayPassword: !this.state.signInDisplayPassword,
    });
  }
  toggleSignUpDisplayPassword() {
    this.setState({
      signUpDisplayPassword: !this.state.signUpDisplayPassword,
    });
  }
  toggleSignUpDisplayPasswordConfirm() {
    this.setState({
      signUpDisplayPasswordConfirm: !this.state.signUpDisplayPasswordConfirm,
    });
  }

  async componentDidMount() {
    this.props.collapsedAllMenu();
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  handleChecked = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  };

  showModalSignUp = async () => {
    this.props.signupOpenNoti(false);
  };

  login = () => {
    if (this.state.username !== "" && this.password !== "") {
      this.props.authSignIn({
        username: this.state.username,
        password: this.state.password,
        page_lang: this.props.locale.locale,
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.auth.auths.errorStatus === "Ready to create account" &&
      this.state.activeTab !== 2
    ) {
      this.setState({
        activeTab: 2,
        action: "Register",
      });
    }
  }

  handleClick = (e) => {
    this.inputElement.click();
  };

  render() {
    const { authMember } = this.props;
    let iconEye, inputType;
    inputType = "password";
    iconEye = "icon icon-ico-eye-2";
    // inputType1 = "password";
    // iconEye1 = "icon icon-ico-eye-2";
    // inputType2 = "password";
    // iconEye2 = "icon icon-ico-eye-2";

    if (this.state.signInDisplayPassword) {
      inputType = "text";
      iconEye = "icon icon-ico-eye-1";
    }

    if (this.state.signUpDisplayPassword) {
      // inputType1 = "text";
      // iconEye1 = "icon icon-ico-eye-1";
    }
    if (this.state.signUpDisplayPasswordConfirm) {
      // inputType2 = "text";
      // iconEye2 = "icon icon-ico-eye-1";
    }
    if (authMember && authMember.success) {
      document.location = "/#/";
    }

    return (
      <>
        <div className="authen-banner">
          <img src={authenBanner} alt="Eastspring Wealth Privilege" className="w-100" />
          <div className="authen-category">
            <div className="justify-content-center text-center">
              {/*<div className="row text-center col-12 mx-auto">
                <div
                  className={`authen-category-item col pt-2 pb-3 ${
                    this.state.activeTab === 1 && "active"
                  }`}
                  onClick={() => this.toggle(1)}
                >
                  <IntlMessages id="authen.sign-in"></IntlMessages>
                </div>

                <div
                  className={`authen-category-item col pt-2 pb-3 ${
                    this.state.activeTab === 2 && "active"
                  }`}
                  onClick={() =>
                    this.state.action === "Register"
                      ? this.toggle(2)
                      : this.showModalSignUp()
                  }
                >
                  <IntlMessages id="authen.sign-up"></IntlMessages>
                </div>
              </div>*/}
            </div>
          </div>
          {/* <div className="div-gradient-authen"></div> */}
        </div>

        {this.state.activeTab === 1 ? (
          <>
            <div className="sign-in-page container text-left ">
              <div className="col-12 mx-auto">
                <h2>
                  <IntlMessages id="authen.sign-in.title" />
                </h2>
                <form className="form-login" autoComplete="off">
                  <div className="sign-in-form">
                    <div className="form-group">
                      <div className="position-relative">
                        <label htmlFor="username">
                          <IntlMessages id="authen.sign-in.privilegeCode"></IntlMessages>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="username"
                          name="username"
                          onChange={(e) => {
                            this.setState({
                              username: e.currentTarget.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="position-relative">
                        <button
                          type="button"
                          className="switch-eye"
                          tabIndex="-1"
                          onClick={() => {
                            this.toggleSignInDisplayPassword();
                          }}
                        >
                          <i className={iconEye}></i>
                        </button>
                        <label htmlFor="password">
                          <IntlMessages id="authen.sign-in.password"></IntlMessages>
                        </label>

                        <input
                          type={inputType}
                          className="form-control"
                          id="password"
                          name="password"
                          onChange={(e) => {
                            this.setState({
                              password: e.currentTarget.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    {/* <p className="error-desc mt-4">
                      <Link
                        to="/request-reset-password"
                        onClick={() => {
                          this.props.authClosePopup();
                        }}
                      >
                        <IntlMessages id="authen.sign-in.forgot" />
                      </Link>
                    </p> */}
                  </div>
                  <button
                    className="submit-button"
                    type="button"
                    disabled
                    onClick={() => {
                      // this.login();
                    }}
                  >
                    <IntlMessages id="authen.sign-in.button" />
                  </button>

                  <button
                    className="btn btn-wrs-clear my-3"
                    type="button"
                    onClick={() => {
                      this.props.authClosePopup();
                    }}
                  >
                    CANCEL
                  </button>
                  <div className="w-100 text-center logoWRSPageLogin">
                  <img src={LogoWrs} alt="World Reward Solutions"/>
                    <p>Powered by<br/>World Reward Solutions</p>
                  </div>
                </form>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        {this.state.activeTab === 2 ? (
          <>
            <div className="sign-up-page container text-left ">
              <div className="col-12 mx-auto">
                <h2>
                  <IntlMessages id="authen.sign-up.title" />
                </h2>
                {this.state.action !== "Register" ? (
                  ""
                ) : (
                  <div className="animated fadeIn">
                    <form
                      className="form-horizontal"
                      onSubmit={() => {
                        // this.props.memberRegister(formValues);
                      }}
                    >
                      <input type="hidden" name="gigya_uid" />
                      <input type="hidden" name="user_signup_token" />
                      <Field
                        name="name"
                        type="text"
                        component={renderFieldInputText}
                        label="Name *"
                      />
                      <Field
                        name="mobile"
                        type="text"
                        component={renderFieldInputText}
                        label="Mobile *"
                      />
                      <Field
                        name="username"
                        type="username"
                        component={renderFieldInputText}
                        label="Email *"
                      />
                      <Field
                        name="password"
                        type="password"
                        component={renderFieldInputText}
                        label="Password *"
                      />
                      <Field
                        name="re_password"
                        type="password"
                        component={renderFieldInputText}
                        label="Confirm Password *"
                      />
                      <Button
                        type="button"
                        color="primary"
                        style={{ width: "100%" }}
                        id="btn-sign-up"
                        onClick={() => this.callModal()}
                      >
                        {" "}
                        SIGN UP{" "}
                      </Button>
                      <Button
                        type="submit"
                        color="danger"
                        style={{ display: "none" }}
                        id="btn-send-sign-up"
                        ref={(input) => (this.inputElement = input)}
                      >
                        Register
                      </Button>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        { /* <PopupSignUpNoti /> */}
        <PopupSignInNotFound />
      </>
    );
  }
}

function validate(values) {
  const errors = {};
  var regPhoneNo = new RegExp("^0[0-9]+$");
  if (!values.mobile) {
    errors.mobile = "Required";
  } else if (!regPhoneNo.test(values.mobile)) {
    errors.mobile = "Phone number wrong Pattern";
  } else if (values.mobile.length !== 10) {
    errors.mobile = "Must be 10 characters";
  }

  if (!values.name) {
    errors.name = "Required";
  } else if (values.name.length > 100) {
    errors.name = "Must be 100 characters or less";
  }
  if (!values.username) {
    errors.username = "Required";
  }

  if (!values.password) {
    errors.password = "Required";
  } else if (values.password.length > 100) {
    errors.password = "Must be 100 characters or less";
  } else if (values.password.length < 6) {
    errors.password = "Must be 6 characters or more";
  }

  if (!values.re_password) {
    errors.re_password = "Required";
  } else if (values.re_password !== values.password) {
    errors.re_password = "Password and Confirm Password not match";
  }
  return errors;
}

const mapStateToProps = ({ form, setting, auth }) => {
  let formValues;
  let initialValues;
  const { locale } = setting;
  return { formValues, locale, auth, initialValues };
};

signInModal = reduxForm({ validate, form: "FormRegister" })(signInModal);

export default connect(mapStateToProps, {
  authSignIn,
  collapsedAllMenu,
  signupOpenNoti,
  signinOpenNotFound,
  validateToken,
  authClosePopup,
})(signInModal);
